// Commandes pour le moteur Engine
import { Position } from '@/engine/entities/Transform/Position';
import { Scale } from '@/engine/entities/Transform/Scale';
import { Size } from '@/engine/entities/Size';
import { Rotation } from '@/engine/entities/Transform/Rotation';

export class UnselectElementCommand {
    constructor() {
        // Commande pour désélectionner un élément
    }
}

export class SelectElementCommand {
    constructor(elementId: string) {
        // Commande pour sélectionner un élément
    }
}

export class CreateCommand {
    public type!: string;
    public content!: any;
    public pos!: Position;
    public scale!: Scale;
    public size!: Size;
    public rotation!: Rotation;
    public options?: Record<string, any>;
    public clipPath?: any;
    /** Sidecar masque BO (useThemeLoader) — doit etre copie sur l'entite Image avant reload. */
    public _localClip?: { clipPath: any; relativeProps: Record<string, unknown> } | null;
    public colorGroups?: any[];
    public isDuplicated?: boolean;
    public canBeUnlocked?: boolean;
    public top?: number;
    public left?: number;

    constructor() {
        // Commande pour créer un élément
    }
}

export class DeleteCommand {
    constructor(elementId: string) {
        // Commande pour supprimer un élément
    }
}

export class RepositionImageCommand {}

export class MoveToCommand {
    public uuid!: string;
    public position!: Position;
}

export class MoveCommand {
    public uuid!: string;
    public deltaPos!: any;

    constructor(elementId?: string, position?: any) {
        // Commande pour déplacer un élément
        if (elementId) {
            this.uuid = elementId;
        }
        if (position) {
            this.deltaPos = position;
        }
    }
}

export class RotateCommand {
    public uuid!: string;
    public angle!: number;

    constructor(elementId?: string, rotation?: number) {
        // Commande pour faire tourner un élément
        if (elementId) {
            this.uuid = elementId;
        }
        if (rotation !== undefined) {
            this.angle = rotation;
        }
    }
}

export class RotateTowardCommand {
    public uuid!: string;
    public position!: any;

    constructor(elementId?: string, position?: any) {
        // Commande pour faire tourner un élément vers une position
        if (elementId) {
            this.uuid = elementId;
        }
        if (position) {
            this.position = position;
        }
    }
}

export class ScaleCommand {
    public uuid!: string;
    public scaleX!: number;
    public scaleY!: number;

    constructor(elementId?: string, scale?: any) {
        // Commande pour redimensionner un élément
        if (elementId) {
            this.uuid = elementId;
        }
        if (scale) {
            this.scaleX = scale.x || scale.scaleX;
            this.scaleY = scale.y || scale.scaleY;
        }
    }
}

export class UpdateCommand {
    constructor(elementId: string, updates: any) {
        // Commande pour mettre à jour un élément
    }
}

export class ToggleLockCommand {
    constructor(elementId: string) {
        // Commande pour verrouiller/déverrouiller un élément
    }
}

export class MoveLayerCommand {
    constructor(elementId: string, layerIndex: number) {
        // Commande pour déplacer un élément dans les couches
    }
}

export class ReorderElementCommand {
    constructor(elementId: string, newIndex: number) {
        // Commande pour réorganiser un élément
    }
}

export class CloneCommand {
    constructor(elementId: string) {
        // Commande pour cloner un élément
    }
}

export enum UpdateType {
    POSITION = 'position',
    SCALE = 'scale',
    ROTATION = 'rotation',
    COLOR = 'color',
    TEXT = 'text',
    IMAGE = 'image'
}
